var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.26 41.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #30a3c5;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Candle_Icon",
    "data-name": "Candle Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.38,16.51c-1.99-3.07.98-6.81.98-6.81,3.17,4.99,1.11,6.81,1.11,6.81,4.5-1.99,4.07-5.78,1.68-9.42-2.72-4.13.75-7.09.75-7.09-2.8.3-6.3,3.68-7.5,9.1-1.25,5.64,2.98,7.41,2.98,7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.33,37.91v-18.78c0-.7-.65-1.23-1.34-1.07l-3.87.88v-3.11c0-.28-.23-.51-.51-.51h-.3c-.28,0-.51.23-.51.51v3.41l-4.4,1c-.5.11-.85.56-.85,1.07v16.6H0c.03.05.06.1.09.15,1.35,2.28,3.83,3.65,6.48,3.65h13.13c2.65,0,5.12-1.37,6.48-3.65.03-.05.06-.1.09-.15h-6.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandleIcon);
export default __webpack_public_path__ + "static/media/candle-icon.3a8148476480e55fac91f2c78fce00c2.svg";
export { ForwardRef as ReactComponent };